import { z } from "zod";
import { Timestamps } from "../common/index.ts";
import { AttachmentId, EntityId, CustomerId } from "../fsm/fsm.schema.ts";
import { RequestId } from "../requests/requests.schema.ts";

export const AttachmentDto = z
  .object({
    id: AttachmentId,
    customerId: CustomerId,
    storagePath: z.string().min(1),
    fileName: z.string().min(1),
    fileSize: z.number().int().positive(),
    contentType: z.string().min(1),
    uploadedBy: EntityId.nullable(),
    url: z.string().optional(), // Signed URL for viewing
  })
  .merge(Timestamps);

export type AttachmentDto = z.infer<typeof AttachmentDto>;

export const CreateAttachmentInput = z.object({
  customerId: CustomerId,
  storagePath: z.string().min(1),
  fileName: z.string().min(1),
  fileSize: z.number().int().positive(),
  contentType: z.string().min(1),
  uploadedBy: EntityId.optional(),
});

export type CreateAttachmentInput = z.infer<typeof CreateAttachmentInput>;

export const LinkAttachmentsToRequestInput = z.object({
  requestId: RequestId,
  attachmentIds: z.array(AttachmentId).min(1),
  customerId: CustomerId,
});

export type LinkAttachmentsToRequestInput = z.infer<
  typeof LinkAttachmentsToRequestInput
>;
